import { Box } from "@storyofams/react-ui";
import { DynamicSections } from "~components/common/Story";
import { DynamicSection } from "~components/common/Story/blocks/Dynamic";
import { ProductSlider } from "../ProductSlider";
import { InformationTabs } from "./InformationTabs";

export const Description = ({ story, product, bundles }) => {
  return (
    <Box>
      {bundles && !!bundles?.length && (
        <ProductSlider
          centered={false}
          overflow={"hidden"}
          title={"Koop als bundel en bespaar"}
          description={product.title + " is onderdeel van deze bundels"}
          isBundles
          mb={3}
          products={bundles as any}
        />
      )}
      {story?.content?.components && (
        <DynamicSections sections={story?.content.components} />
      )}
      {!story?.content?.isTabsDisabled && (
        <InformationTabs
          product={product}
          isDescriptionDisabled={story?.content.isDescriptionDisabled}
          isIngredientsDisabled={story?.content?.IsIngredientsDisabled}
        />
      )}
      {story?.content.after_description && (
        <DynamicSection content={story?.content.after_description[0]} />
      )}
      <Box />
      {!story?.content && (
        <Box
          mt="32px"
          width={"100%"}
          height={"100%"}
          // onClick={() => posthog.capture("Clicked Greenspark Homepage")}
          dangerouslySetInnerHTML={{
            __html: `<div
                class="reeview-app-widget"
                id="reeview-app-widget_671a7388fef448002a0b2f83"
              ></div>`,
          }}
        />
      )}
    </Box>
  );
};
